<template>
  <TrainingWomen v-if="$store.getters.isMH && $i18n.locale() !== 'gr' && $i18n.locale() !== 'ie' && $i18n.locale() !== 'my'" />
  <TrainingMen v-else />
</template>

<script>
import TrainingWomen from '@/components/Settings/TrainingWomen'
import TrainingMen from '@/components/Settings/TrainingMen'

export default {
  components: {
    TrainingWomen,
    TrainingMen
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Settings/Training.vue